import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import PageLoadFailure from './components/PageLoadFailure';
import { installRouteLoadRecovery, recoverRouteLoad } from './utils/routeLoadRecovery';
import './index.css';

installRouteLoadRecovery();

/*
 * `reducedMotion="user"` makes every framer-motion animation in the app honour
 * prefers-reduced-motion without a single component asking. Transform and layout
 * animations are skipped to their final state; opacity still crossfades, which is
 * the distinction the OS setting actually asks for. Set here rather than per
 * section so a new animated component cannot forget.
 */
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <MotionConfig reducedMotion="user">
          <ErrorBoundary onError={error => recoverRouteLoad(error)} fallback={<PageLoadFailure />}><App /></ErrorBoundary>
        </MotionConfig>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
